import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24257913"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-12 d-flex flex-row partners" }

import constants from "@/shared/constants";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomePagePartnersSection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(constants).universities, (partner) => {
          return (_openBlock(), _createBlock(_component_v_img, {
            key: partner.id,
            src: partner.photo,
            "max-width": "120px",
            "max-height": "120px",
            "min-width": "120px",
            class: "my-4"
          }, null, 8, ["src"]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})